import { render } from "./List.vue?vue&type=template&id=71938e5a&ts=true&lang=pug"
import script from "./List.vue?vue&type=script&setup=true&lang=ts"
export * from "./List.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./List.vue?vue&type=style&index=0&id=71938e5a&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__